module.exports = __webpack_public_path__ + "static/img/5b.644c1cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5b.jpg
// module id = geFo
// module chunks = 0